import { createSelector } from "reselect";

const selectPlayero = (state) => state.playero;

export const selectLoadingProcess = createSelector(
  [selectPlayero],
  (currentState) => currentState.loadingProcess
);
